'use client'

import { Label } from "@/components/ui/label"
import { SidebarInput } from "@/components/ui/sidebar"
import { useI18n } from "@/contexts/lang-context"
import { Search } from "lucide-react"
import { useEffect, useState } from "react"

interface SidebarSearchProps {
  onChangeSearch: (search?: string) => void
}
export function SidebarSearch({ onChangeSearch }: SidebarSearchProps) {
  const { t } = useI18n()
  const [search, setSearch] = useState<string>("")

  useEffect(() => {
    onChangeSearch(search)
  }, [search])

  return (
    <div className="relative">
      <Label htmlFor="search" className="sr-only">
        Search
      </Label>
      <SidebarInput
        id="search"
        placeholder={t("sidebar.search")}
        className="pl-8"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <Search className="pointer-events-none absolute top-1/2 left-2 size-4 -translate-y-1/2 opacity-50 select-none" />
    </div>
  )
}